<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" scrollable persistent width="750px">
      <v-form
        class="fill-word"
        ref="form"
        v-model="valid"
        v-on:submit.prevent="validate"
      >
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-toolbar-title>
              <v-icon left>mdi-color-helper</v-icon
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.addFillTheBlank'
                )
              }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  dark
                  :disabled="loading"
                  @click="closeDialogQuestion"
                  v-on="on"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.close'
                )
              }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row v-if="randomSetting == true">
              <v-col cols="8">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.chooseQuestionGroup'
                    )
                  }}<span class="red--text">*</span>
                </p>
                <v-autocomplete
                  v-model="selectTagLevel"
                  :items="arrTagLevel"
                  item-text="text"
                  class="mb-2 body-1"
                  item-value="id"
                  @change="changeTag(selectTagLevel)"
                  outlined
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.chooseQuestionGroup'
                    )
                  "
                  background-color="white"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4"
                ><p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.score'
                    )
                  }}
                </p>
                <v-text-field
                  disabled
                  outlined
                  v-model.number="scoreTag"
                  type="number"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.question'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <quill-editor
                  required
                  class="editor"
                  v-model="question"
                  :rules="questionRules"
                  clearable
                  ref="question"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <div class="d-flex mb-2">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.addVoiceOpt'
                      )
                    }}
                  </p>
                </div>
                <!-- <div class="upload-btn-wrapper">
                  <button class="btn-choose body-1 font-weight-medium">
                    <v-icon>mdi-upload</v-icon>Upload audio
                  </button>
                  <input
                    type="file"
                    name="myfile"
                    @change="preview"
                    accept="image/png, image/jpeg, image/bmp"
                  />
                </div>-->

                <v-card height="100" outlined v-if="audio_id === null">
                  <div class="text-center center-panel">
                    <v-btn
                      outlined
                      color="blue-grey"
                      @click="openMediaDialog('audio')"
                    >
                      <v-icon left>mdi-volume-high</v-icon
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.addVoice'
                        )
                      }}
                    </v-btn>
                  </div>
                </v-card>
                <v-card height="85%" v-if="audio_id" outlined>
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 error--text text-capitalize"
                        color="white"
                        v-if="audio_id"
                        @click="deletemedia('audio')"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-5">
                      <vuetify-audio
                        :file="audio_url"
                        :audioPlaying.sync="audioPlaying"
                      ></vuetify-audio>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="6">
                <div class="d-flex mb-2">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.addVdoOpt'
                      )
                    }}
                  </p>
                </div>
                <v-card height="100" outlined v-if="video_id === null">
                  <div class="text-center center-panel">
                    <v-btn
                      outlined
                      color="blue-grey"
                      @click="openMediaDialog('video')"
                    >
                      <v-icon left>mdi-video</v-icon
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.addVdo'
                        )
                      }}
                    </v-btn>
                  </div>
                </v-card>
                <v-card height="85%" outlined v-if="video_id">
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 error--text text-capitalize"
                        color="white"
                        v-if="video_id"
                        @click="deletemedia('video')"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.delete'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-5">
                      <div class="videoPlayer ma-auto">
                        <video-player
                          class="video-player-box videoContainer"
                          ref="videoPlayer"
                          :options="playerOptions"
                          :playsinline="true"
                          customEventName="customstatechangedeventname"
                          @ready="playerReadied"
                        ></video-player>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.percent'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <v-text-field
                  outlined
                  type="number"
                  v-model.number="percentScore"
                  maxlength="3"
                  :rules="percentRules"
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.percent'
                    )
                  "
                  required
                  clearable
                  append-outer-icon="mdi-percent"
                  prepend-inner-icon="mdi-greater-than-or-equal"
                  class="percentScoreTextField"
                  min="0"
                  max="100"
                  @change="checkMinPercentScore"
                ></v-text-field>
              </v-col>
              <v-col cols="6" v-if="randomSetting == false">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.score'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <v-text-field
                  outlined
                  type="number"
                  maxlength="10"
                  v-model.number="question_score"
                  :rules="scoreRules"
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.score'
                    )
                  "
                  required
                  clearable
                  min="0"
                  @change="checkMinQuestionScore"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-alert class="mb-0" text type="info" border="left">
                  <strong class="font-weight-bold">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.msg1'
                    )
                  }}</strong>
                  <br />
                  <strong class="font-weight-bold">
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.msg2'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                  <br />{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.msg3'
                    )
                  }}
                  <v-divider class="my-3"></v-divider>
                  <strong class="font-weight-bold">
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.msg4'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                  <br />{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.msg5'
                    )
                  }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="title mb-0">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.packChoices'
                    )
                  }}
                </p>
                <p class="subtitle-1" v-if="answer.length == 0">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.choiceMsg3'
                    )
                  }}
                </p>
              </v-col>
            </v-row>
            <div v-for="(choice, index) in answer" :key="index">
              <v-row>
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-text class="pb-0">
                      <v-row class="mx-0">
                        <div class="subtitle-1">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.choices'
                            ) +
                            (index + 1) +
                            ' '
                          }}
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="choice.boolean == false"
                          :disabled="bools == true"
                          elevation="0"
                          class="mb-0 body-2 text-primary text-capitalize"
                          color="white"
                          @click="editOptionAnswer(choice)"
                        >
                          <p class="mb-0">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.courseList.edit'
                              )
                            }}
                          </p>
                        </v-btn>
                        <v-divider
                          v-if="choice.boolean == false"
                          inset
                          vertical
                          class="mb-2 mx-1"
                        ></v-divider>
                        <v-btn
                          v-if="choice.boolean == false"
                          :disabled="answer.length <= 1 || bools == true"
                          elevation="0"
                          class="mb-0 body-2 error--text text-capitalize"
                          color="white"
                          @click="openRemoveItemDialog(choice)"
                        >
                          <p class="mb-0">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.delete'
                              )
                            }}
                          </p>
                        </v-btn>
                        <v-btn
                          v-if="choice.boolean == true"
                          elevation="0"
                          class="mb-0 body-2 text-primary text-capitalize"
                          color="white"
                          @click="confirmOption(choice)"
                        >
                          <p class="mb-0">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.ok'
                              )
                            }}
                          </p>
                        </v-btn>
                        <v-divider
                          v-if="choice.boolean == true"
                          inset
                          vertical
                          class="mb-2 mx-1"
                        ></v-divider>
                        <v-btn
                          v-if="choice.boolean == true"
                          elevation="0"
                          class="mb-0 body-2 text-capitalize"
                          color="white"
                          @click="canCelEditOptionAnswer(choice)"
                        >
                          <p class="mb-0">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                              )
                            }}
                          </p>
                        </v-btn>
                      </v-row>
                    </v-card-text>
                    <v-card-title class="py-0">
                      <p v-if="choice.boolean == false">{{ choice.text }}</p>
                      <v-text-field
                        v-if="choice.boolean == true"
                        outlined
                        v-model="choice.text"
                        ref="answer"
                        :placeholder="
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.choice'
                          )
                        "
                      ></v-text-field>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <!-- <v-row class="justify-center ma-3">
              <v-btn
                :disabled="bools == true"
                elevation="0"
                class="pl-5 pr-5 mb-0 body-2 text-primary text-capitalize"
                color="white"
                @click="addRowAnswer"
              >
                <v-icon left>mdi-plus</v-icon>
                {{
                  $vuetify.lang.t(
                    "$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.addChoice"
                  )
                }}
              </v-btn>
            </v-row> -->
            <v-row>
              <v-col cols="12" class="mt-5 ma-0 pa-0">
                <v-card class="pa-5" elevation="0" color="grey lighten-5">
                  <v-col cols="12" class="pa-0">
                    <p class="title">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.fillChoice'
                        )
                      }}
                      <span class="red--text">*</span>
                    </p>
                    <p class="subtitle-1">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.choiceMsg1'
                        )
                      }}
                    </p>
                    <v-text-field
                      outlined
                      v-model="addAnswer"
                      ref="answer"
                      :placeholder="
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.choice'
                        )
                      "
                      required
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        :disabled="addAnswer == ''"
                        elevation="0"
                        class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
                        @click="addRowAnswer"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.addChoice'
                          )
                        }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-card class="pa-5" elevation="0" color="grey lighten-5">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.answerDescription'
                    )
                  }}
                </p>
                <p class="subtitle-1">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.choiceMsg2'
                    )
                  }}
                </p>
                <quill-editor
                  class="editor"
                  v-model="answer_description"
                  :rules="answerDescriptionRules"
                  ref="answer_description"
                  :options="editorOption"
                />
              </v-card>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              :disabled="loading"
              @click="closeDialogQuestion"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                )
              }}</v-btn
            >
            <v-btn
              elevation="0"
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="validate(null)"
              :disabled="!validationForm() || loading"
              :loading="loading"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.save'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.saveDone'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.saveDoneDetail'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.done'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRemoveItem" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.confirmDeleteChoice'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.confirmDeleteChoiceDetail'
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            dark
            outlined
            @click="dialogRemoveItem = false"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.cancel'
              )
            }}</v-btn
          >
          <v-btn color="error darken-1" dark @click="removeItem">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.confirm'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.saveDone'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.saveDoneDetail'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.done'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warnningToSaveDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
            )
          }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="confirmCloseDialog()"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.exit')
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSaveFail" persistent max-width="450" color="white">
      <v-card class="pa-3">
        <v-card-title class="mb-3">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
          )
        }}</v-card-title>
        <v-card-text>
          <p class="subtitle-1">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.saveFailMsg'
              )
            }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="dialogSaveFail = false"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <insert-media-dialog
      :isMediaOpen.sync="mediaDialog"
      :isMediaClose="closeMediaDialog"
      :on-set-video="setVideo"
      :on-set-audio="setAudio"
      :typeMedia.sync="mediaType"
    ></insert-media-dialog>
  </v-row>
</template>

<script>
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import { getListTagLevel } from '@/service/course/exam.js';
import {
  insertQuestion,
  getQuestionById,
  updateQuestion,
} from '@/service/course/exam';
import insertMediaDialog from '@/views/course/dialog/insertMediaDialog.vue';
import { serverName } from '@/service/configApi';
import { getPrivateVideo } from '@/service/upload/upload.js';

import videojs from 'video.js';
window.videojs = videojs;
import $ from 'jquery';
import { getPrivateFile } from '@/service/upload/upload.js';

// hls plugin for videojs6
require('videojs-contrib-hls/dist/videojs-contrib-hls.js');

export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    examId: {
      type: String,
    },
    randomSetting: {
      type: Boolean,
    },
    questionId: {
      type: String,
    },
    questionType: {
      type: String,
    },
    questions: {},
    articleId: {
      type: String,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reorderLecture: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
  },

  components: {
    insertMediaDialog,
    // VuetifyAudio: () => import("vuetify-audio"),
    VuetifyAudio: () => import('@/components/vuetify-audio'),
    videoPlayer,
  },
  data() {
    return {
      valid: true,
      dialog: false,
      dialog_fillWord: false,
      notifications: false,
      sound: true,
      widgets: false,
      question: '',
      question_score: '',
      answer: [],
      answer_description: '',
      // nameRules: [v => !!v || "กรุณากรอกคะแนน"],
      rows: [1],
      chars: [],
      answer_select: [],
      answer_correct: 0,
      loading: false,
      questionRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.questionRules'
          ),
      ],
      answerDescriptionRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.answerDescriptionRules'
          ),
      ],
      scoreRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.scoreRules1'
          ),
        (v) =>
          v > 0 ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.scoreRules2'
          ),
      ],
      percentRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.percentRules1'
          ),
        (v) =>
          (v >= 0 && v <= 100) ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.percentRules2'
          ),
      ],
      answerRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertFillTheBlank.answerRules'
          ),
      ],
      percentScore: 0,
      editorOption: {},

      // audio
      audio_url: '',

      // mediaDialog
      mediaDialog: false,
      audio_id: null,
      video_id: null,

      playerOptions: {
        // videojs options
        fluid: true,
        height: '500',
        // width: '300',
        hls: true,
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'application/x-mpegURL',
            src:
              'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          },
        ],
        // poster: "/static/images/author.jpg"
      },
      successUpload: false,
      isCheckComplete: false,
      urlVideo:
        // "https://fleet.byteark.com/player?url=http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8",
        'http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8',
      cantGetLink: false,
      showUploadPercent: false,
      mediaType: '',
      audioPlaying: false,
      addAnswer: '',
      tempChoiceAnswer: '',
      editChoice: false,
      dialogRemoveItem: false,
      dialogSuccess: false,

      bools: false,
      arrTagLevel: [],
      selectTagLevel: null,
      scoreTag: null,
      selectTagBool: false,
      itemChoice: [],
      pageLevel: 1,
      pageLevelLength: 1,
      warnningToSaveDialog: false,
      dialogSaveFail: false,
    };
  },
  watch: {
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.questionId) {
          let result = await getQuestionById({ id: this.questionId });
          await this.getListTagLevel(this.examId);
          this.oldQuestion = result;
          this.question = result.question;
          this.question_score = result.score;
          // this.answer = result.correctText;
          this.answer_description = result.note;

          this.percentScore = result.persentCorrectText;
          this.audio_id = result.audio;
          this.video_id = result.video;

          this.audio_id ? this.getAudioPreview() : '';
          this.video_id ? this.getPreview('video') : '';
          console.log(result);
          this.answer = [];
          result.correctText.forEach((text) => {
            this.answer.push({
              text: text,
              boolean: false,
            });
          });
          this.arrTagLevel.forEach((level, index) => {
            if (result.level == level.id) {
              console.log(result.level + ' ' + level.id + ' ' + level.text);
              this.selectTagLevel = level.id;
              this.scoreTag = level.score;
            }
          });
        } else {
          this.valid = true;
          this.dialog_1 = false;
          this.question = '';
          this.question_score = '';
          this.percentScore = '';
          this.answer_description = '';
          this.answer = [];
          this.itemChoice = [];
          this.selectTagLevel = null;
          this.scoreTag = null;
          this.oldQuestion = {};
          this.chars = [];
          this.answer_select = [];
          this.answer_correct = 0;
          this.audio_id = null;
          this.video_id = null;
          // this.$refs.form.reset();
          this.addAnswer = '';
          await this.getListTagLevel(this.examId);
          this.$refs.form.resetValidation();
        }
      } else {
        try {
          // $(".videoPlayer")[0].player.pause();
          $('video').each(function () {
            $(this).get(0).pause();
          });
        } catch (error) {
          console.log(error);
        }
        try {
          this.audio_url = '';
          this.audioPlaying = false;
          // $('#player')[0].pause();
          // $('#player')[0].currentTime = 0;
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  methods: {
    validationForm() {
      let bool = true;
      // this.answer.forEach((item) => {
      //   if (item && item.length < 1) {
      //     bool = false;
      //   }
      // });
      if (!this.selectTagLevel && this.typeOfExam == true) {
        bool = false;
      }

      if (this.answer.length == 0) {
        bool = false;
      }
      return this.valid && this.question != '' && bool;
    },
    removeRow: function (item) {
      let index = this.answer.indexOf(item);
      if (this.answer.length > 1) {
        this.answer.splice(index, 1);
      } else {
        this.answer.splice(index, 1);
        this.bools = false;
      }
    },
    addRowAnswer: function () {
      this.tempChoiceAnswer = '';
      this.answer.push({ text: this.addAnswer, boolean: false });
      this.bools = false;
      this.addAnswer = '';
    },
    editOptionAnswer(item) {
      console.log(item.text);
      this.tempChoiceAnswer = item.text;
      item.boolean = true;
      this.bools = true;
    },
    confirmOption(item) {
      item.boolean = false;
      this.bools = false;
    },
    canCelEditOptionAnswer(item) {
      let index = this.answer.indexOf(item);
      if (this.tempChoiceAnswer == '') {
        this.removeRow(item);
        this.bools = false;
      } else {
        console.log(item.text + ' ' + this.tempChoiceAnswer);
        item.text = this.tempChoiceAnswer;
        item.boolean = false;
        this.bools = false;
      }
    },
    openRemoveItemDialog(item) {
      let index = this.answer.indexOf(item);
      this.itemChoice = item;
      this.dialogRemoveItem = true;
      if (this.answer.length > 1) {
        this.removeItemIndex = index;
      }
    },
    async removeItem() {
      if (this.answer.length > 1) {
        if (this.answer_correct === this.removeItemIndex) {
          this.answer_correct = 0;
        } else if (this.answer_correct > this.removeItemIndex) {
          this.answer_correct = this.answer_correct - 1;
        }
        this.answer.splice(this.removeItemIndex, 1);
      }
      this.validate(this.itemChoice);
      this.dialogRemoveItem = false;
    },
    async getListTagLevel(examId) {
      let params = {
        idexam: examId,
        sort: 'created_at',
        sortby: 1,
        page: this.pageLevel,
        limit: 100,
      };
      this.arrTagLevel = [];
      let result = await getListTagLevel(params);
      console.log(result);
      if (result.data.length != 0) {
        this.settingLevel = true;
        this.typeOfExam = true;
        result.data.forEach((level) => {
          this.arrTagLevel.push({
            id: level._id,
            text: level.title,
            score: level.score,
            sumScore: level.score * level.choose,
            numberOfQuestion: level.choose,
            countQuestion: level.countQuestion,
            boolean: false,
          });
        });
        console.log(this.arrTagLevel);
      } else {
        this.settingLevel = false;
      }
    },
    changeTag(idTag) {
      this.arrTagLevel.forEach((level) => {
        if (idTag == level.id) {
          this.scoreTag = level.score;
          this.selectTagBool = true;
        }
      });
    },
    async validate(valueOption) {
      this.loading = true;
      if (this.$refs.form.validate()) {
        let tag_score = null;
        let level = this.arrTagLevel.find((x) => x.id == this.selectTagLevel);
        if (level != null) {
          tag_score = level.score || 0;
        }

        let question = {
          idexam: this.examId,
          typeQuestion: 'fillgaptext',
          question: this.question,
          correctText: this.answer.map((choice) => choice.text),
          persentCorrectText: this.percentScore,
          note: this.answer_description,
          randomChoice: false,
          score: this.selectTagLevel ? tag_score : this.question_score,
          video: this.video_id,
          audio: this.audio_id,
          level: this.selectTagLevel,
        };
        if (this.articleId) {
          question = {
            ...question,
            articleQuestion: this.articleId,
          };
        }

        if (this.questionId) {
          let resultQuestion = await updateQuestion({
            id: this.questionId,
            ...this.oldQuestion,
            ...question,
          });
          if (resultQuestion) {
            this.bools = false;
            this.loading = false;
            this.dialogSuccess = true;
            valueOption ? (valueOption.boolean = false) : '';
            this.addAnswer = '';
            let result = await getQuestionById({ id: this.questionId });
            this.answer = [];
            console.log(result);
            result.correctText.forEach((text) => {
              this.answer.push({
                text: text,
                boolean: false,
              });
            });
          }
          if (!valueOption) {
            this.closeDialog();
            this.clearDateValidation();
          }
        } else {
          if (!valueOption) {
            let resultQuestion = await insertQuestion(question);
            if (resultQuestion) {
              this.loading = false;
              this.dialogSuccess = true;
              valueOption ? (valueOption.boolean = false) : '';
              this.addAnswer = '';
              this.bools = false;
              let result = await getQuestionById({ id: resultQuestion._id });
              this.answer = [];
              result.choices.forEach((text) => {
                this.answer.push({
                  ...text,
                  boolean: false,
                });
              });
            }
            this.closeDialog();
            this.clearDateValidation();
          } else {
            this.dialogSuccess = true;
            valueOption ? (valueOption.boolean = false) : '';
            this.addAnswer = '';
            this.bools = false;
          }
        }
        // await this.close();
      } else {
        this.dialogSaveFail = true;
      }
    },
    async closeDialogQuestion() {
      let data = {
        question: this.question,
        question_score: this.question_score,
        answer_description: this.answer_description,
        setRandomChoice: this.setRandomChoice,
        audio_id: this.audio_id,
        video_id: this.video_id,
        answer: this.answer,
        arrTagLevel: this.arrTagLevel,
        percentScore: this.percentScore,
      };
      console.log('closeDialogQuestion -> data', data);
      if (JSON.stringify(this.oldQuestion) !== JSON.stringify(data)) {
        this.warnningToSaveDialog = true;
      } else {
        this.closeDialog();
        this.clearDateValidation();
      }
    },
    confirmCloseDialog() {
      this.warnningToSaveDialog = false;
      this.closeDialog();
      this.clearDateValidation();
    },
    clearDateValidation() {
      this.valid = true;
      this.dialog_1 = false;
      this.question = '';
      this.addAnswer = '';
      this.question_score = '';
      this.answer_description = '';
      this.setRandomChoice = false;
      this.answer = [];
      this.arrAnswer = [];
      this.itemChoice = [];
      this.selectTagLevel = null;
      this.scoreTag = null;
      this.bools = false;
      this.oldQuestion = {};
      this.answer_select = [];
      this.answer_correct = null;
      this.audio_id = null;
      this.video_id = null;
      this.percentScore = '';
      this.chars = [];
      this.$refs.form.resetValidation();
    },
    checkMinQuestionScore() {
      if (this.question_score < 0) this.question_score = 0;
    },
    checkMinPercentScore() {
      if (this.percentScore < 0) this.percentScore = 0;
      if (this.percentScore > 100) this.percentScore = 100;
    },
    async close() {
      this.answer = [];
      this.bools = false;
      this.closeDialog();
      this.$refs.form.resetValidation();
    },
    async closeMediaDialog() {
      this.mediaDialog = false;
      //this.registerTutoralert = true;
    },
    setVideo(data) {
      this.video_id = data;
      this.getPreview('video');
    },
    setAudio(data) {
      this.audio_id = data;
      this.getAudioPreview();
    },
    async getAudioPreview() {
      this.audio_url = await getPrivateFile(this.audio_id);
      if (this.audio_url) {
        this.isCheckComplete = true;
        this.audioPlaying = true;
      }
    },
    async getPreview(type) {
      let resultLink = await getPrivateVideo(
        type == 'audio' ? this.audio_id : this.video_id
      );
      if (resultLink.isCheckComplete !== undefined) {
        this.isCheckComplete = resultLink.isCheckComplete;
        if (resultLink.isCheckComplete) {
          type == 'audio'
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.url
          // (this.urlVideo = resultLink.url);
          // this.oldVideoUrl = resultLink.url
          this.audioPlaying = true;
        } else {
          type == 'audio'
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.urllocalhost

          this.audioPlaying = true;
        }

        //this.urlVideo = `https://fleet.byteark.com/player?url=${resultLink}`;
        // this.successUpload = true;
        // this.pendingUpload = false;
      }
    },
    deletemedia(type) {
      type == 'audio' ? (this.audio_id = null) : (this.video_id = null);
    },
    openMediaDialog(type) {
      type == 'audio' ? (this.mediaType = 'audio') : (this.mediaType = 'video');
      this.mediaDialog = true;
    },
  },
  beforeMount() {
    this.chars = 'abcdefghijklmnopqrstuvwxyz'.split('');
  },
};
</script>
<style lang="scss">
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}
.radioStyle {
  position: absolute;
  margin: 20px;
  padding: 80px;
}
.removeStyle {
  margin-top: 120px;
  margin-left: 80px;
}
.btn-style {
  margin-left: 120px;
  margin-right: 120px;
}
.btn-add-style {
  margin-left: 45px;
  margin-right: 45px;
}
.card-style:focus {
  border-color: #1976d2;
  box-shadow: 0 0 3px 0px #1976d2;
  /* background-color: white; */
  background-color: #1976d2;
}
.card-border {
  border-radius: 28px;
}

p {
  margin: 0 0 5px;
}

.manageButton {
  justify-content: flex-end;
}
.editorQuestion {
  height: 100px;
  margin-bottom: 70px;
}

.fill-word .editor_answer .ql-container {
  min-height: 90px;
}

.fill-word .textField {
  width: 100%;
}

.fill-word .editor .ql-container {
  min-height: 150px;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
  .btn-style {
    margin-left: 60px;
    margin-right: 60px;
  }
  .btn-add-style {
    margin-left: 22.5px;
    margin-right: 22.5px;
  }
}

.justify-content-between {
  justify-content: space-between;
}
.v-text-field--enclosed .v-input__prepend-inner {
  margin-top: 5px !important;
}
.v-text-field--enclosed .v-input__append-inner {
  margin-top: 5px !important;
}
.v-text-field--enclosed .v-input__append-outer {
  margin-top: 5px !important;
}
</style>
<style lang="scss" scoped>
.text-primary {
  color: rgb(66, 154, 216) !important;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.preview-audio {
  box-shadow: none;
  background: transparent !important;
  p {
    display: none;
  }
  .v-card__text {
    button:nth-child(2) {
      display: none;
    }
    button:nth-child(3) {
      display: none;
    }
    .v-progress-linear {
      display: none;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.select-type-audio {
  .v-input--radio-group__input {
    justify-content: center;
  }
}
.border {
  border: 1px solid rgb(195, 195, 195) !important;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%; /* 1:1 Aspect Ratio */
  padding-top: 50%;
  border-radius: 50px;
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.colCenter {
  text-align: center;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}
.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.labelExplan {
  text-align: justify;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */

/* video */
.video-js[tabindex='-1'] {
  width: 100%;
  height: 400px;
}
.videoContainer {
  width: 100%;
  /* height: 400px; */
  margin: 0 auto;
}
@media (max-width: 500px) {
  .videoContainer {
    width: 100%;
    height: auto;
    margin: 0 auto;
  }
}
/* .vjs_video_3{
  width: 200px;
  height: 200px;
} */
.progressContainer {
  max-width: 270px;
  text-align: center;
  width: 90%;
  margin: 0 auto;
  margin-bottom: 160px;
}
.progressContainerError {
  max-width: 270px;
  text-align: center;
  width: 90%;
  margin: 0 auto;
  margin-top: -180px;
  margin-bottom: 160px;
}

/* @media (max-width: 760px) {
  .progressContainer {
    width: 200px;
  }
} */

@media (max-width: 760px) {
  .select-type-upload ul li {
    margin: 0 20px;
  }
}
@media (max-width: 375px) {
  .select-type-upload ul li {
    margin: 0 10px;
  }
}
@media (max-width: 360px) {
  .select-type-upload ul li {
    margin: 0 10px;
  }
}
@media (max-width: 320px) {
  .select-type-upload ul li {
    margin: 0 1px;
  }
}

.vs-progress--background {
  width: 100%;
}
.input-group {
  display: table;
  margin: 0 auto;
}
.input-upload {
  display: table-cell;
}
.uploadfile {
  display: none;
}
.input-group-btn {
  background-color: #ec407a;
  border-color: #ec407a;
  color: #fff;
  margin-left: -2px;
  border-radius: 0;
  width: 60px;
  padding: 0.75rem 0rem !important;
}
.vs-con-input-label {
  width: 400px;
}
.timeLeft {
  text-align: right;
}
.vjs_video_3-dimensions {
  width: 100% !important;
  height: 320px;
}
.upload_description {
  font-size: 12px;
  color: grey;
  margin-top: 5px;
}

@media (max-width: 800px) {
  .resonsive-iframe {
    height: 500px;
  }
  .w-md-50 {
    width: 100%;
  }
}
.center-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.w-md-50 {
  width: 50%;
  margin: 0 auto;
}
</style>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
</style>